import PipedriveReactLoader from "../components/PipedriveReactLoader.tsx";

const ContactUsForm = () => (
  <PipedriveReactLoader
    formId={"1C8G2y2HaO0Vt3v3FKybiarKvaHaxydNRLfCS9Z6rXq4aRkQWIsZiKvJOd8Ku4G5l"}
    formHeight={768}
  />
);
export default ContactUsForm;
